import React, { useEffect, useState } from 'react';
import { Table, Form, FormGroup, Row, Col, Card, CardBody, CardHeader, Label, Input, Button, Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import Select from "react-select";
import { api } from "../../config";
import { ToastContainer } from 'react-toastify';
import { toast } from 'react-toastify';
import { fetchComAuth, fetchComAuthJson } from '../../common/api';

const TelaConfiguracaoFeira = ({ feiraId, editando }) => {
  const [formasOpcoes, setFormasOpcoes] = useState([]);
  const [condicoesOpcoes, setCondicoesOpcoes] = useState([]);
  const [selectedFormas, setSelectedFormas] = useState([]);
  const [selectedCondicoes, setSelectedCondicoes] = useState([]);
  const [expositoresOpcoes, setExpositoresOpcoes] = useState([]);
  const [estandesOpcoes, setEstandesOpcoes] = useState([]);
  const [selectedExpositorBloqueio, setSelectedExpositorBloqueio] = useState([]);
  const [selectedEstandesBloqueio, setSelectedEstandesBloqueio] = useState([]);
  const [configuracaoId, setConfiguracaoId] = useState(null);
  const [logoDevMapaFile, setLogoDevMapaFile] = useState(null);
  const [logoDevMapaUrl, setLogoDevMapaUrl] = useState(null);
  const [bannerFile, setBannerFile] = useState(null);
  const [bannerUrl, setBannerUrl] = useState(null);
  const [bannerMobileFile, setBannerMobileFile] = useState(null);
  const [bannerMobileUrl, setBannerMobileUrl] = useState(null);
  const [enviarEmailReserva, setEnviarEmailReserva] = useState(false);
  const [camposDisponiveis, setCamposDisponiveis] = useState([])
  const [selected, setSelected] = useState([]);
  const [contatosEmail, setContatosEmail] = useState([]);
  const [modalContatoAberto, setModalContatoAberto] = useState(false);
  const [contatoEditandoId, setContatoEditandoId] = useState(null);
  const [emailContato, setEmailContato] = useState('');
  const [camposValidacao, setCamposValidacao] = useState([]);
  const [novoCampoLabel, setNovoCampoLabel] = useState('');

  const [vendaInterna, setVendaInterna] = useState(false);
  const [vendaExterna, setVendaExterna] = useState(false);
  const [renovacaoInterna, setRenovacaoInterna] = useState(false);
  const [renovacaoExterna, setRenovacaoExterna] = useState(false);
  const [enviarCodigoEmailExpositor, setEnviarCodigoEmailExpositor] = useState(false);
  const [enviarEmailNovoUsuario, setEnviarEmailNovoUsuario] = useState(false);
  const [enviarEmailReservaExpositor, setEnviarEmailReservaExpositor] = useState(false);
  const [enviarEmailReservaComercial, setEnviarEmailReservaComercial] = useState(false);
  const [enviarEmailAtualizacaoReservaExpositor, setEnviarEmailAtualizacaoReservaExpositor] = useState(false);
  const [enviarEmailAtualizacaoReservaComercial, setEnviarEmailAtualizacaoReservaComercial] = useState(false);
  const [enviarEmailAtualizarSenha, setEnviarEmailAtualizarSenha] = useState(false);
  const [enviarEmailQueroExpor, setEnviarEmailQueroExpor] = useState(false);


  const adicionarNovoCampo = () => {
    if (!novoCampoLabel.trim()) {
      toast.warning("Informe o nome do campo");
      return;
    }

    const novoCampo = {
      id: Date.now(),
      label: novoCampoLabel.trim()
    };

    setCamposValidacao(prev => [...prev, novoCampo]);
    setNovoCampoLabel('');
    toast.success("Campo adicionado com sucesso!");
  };

  const excluirCampoValidacao = (id) => {
    setCamposValidacao(prev => prev.filter(c => c.id !== id));
  };

  const excluirCampo = async (nomeCampo) => {
    if (!window.confirm("Tem certeza que deseja excluir este campo?")) return;

    try {
      const response = await fetchComAuth(`${api.API_URL}/expositorCampos/${nomeCampo}`, {
        method: 'DELETE'
      })

      if (!response.ok) throw new Error('Erro ao excluir campo');

      setCamposDisponiveis(prev => prev.filter(c => c.value !== nomeCampo));
      toast.success("Campo excluído com sucesso!");
    } catch (err) {
      toast.error("Erro ao excluir campo.");
      console.error(err);
    }
  };

  const removeImage = () => {
    setLogoDevMapaUrl("");
  };

  const removeBanner = () => {
    setBannerUrl("");
  };
  const removeBannerMobile = () => {
    setBannerMobileUrl("");
  };

  const abrirModalContato = (contato = null) => {
    if (contato) {
      setContatoEditandoId(contato.id);
      setEmailContato(contato.email);
    } else {
      limparModalContato();
    }
    setModalContatoAberto(true);
  };
  const limparModalContato = () => {
    setContatoEditandoId(null);
    setEmailContato('');
  };
  const salvarContato = () => {
    if (!emailContato) return;
    const novos = [...contatosEmail];
    if (contatoEditandoId) {
      const idx = novos.findIndex(c => c.id === contatoEditandoId);
      if (idx > -1) {
        novos[idx] = { id: contatoEditandoId, email: emailContato };
      }
    } else {
      novos.push({ id: Date.now(), email: emailContato });
    }
    setContatosEmail(novos);
    setModalContatoAberto(false);
    limparModalContato();
  };
  const excluirContato = (id) => {
    setContatosEmail(contatosEmail.filter(c => c.id !== id));
  };
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setLogoDevMapaUrl(file);
      setLogoDevMapaFile(file);
    }
  };

  const handleFileChangeBanner = (e) => {
    const file = e.target.files[0];
    if (file) {
      setBannerUrl(file);
      setBannerFile(file);
    }
  };

  const handleFileChangeBannerMobile = (e) => {
    const file = e.target.files[0];
    if (file) {
      setBannerMobileUrl(file);
      setBannerMobileFile(file);
    }
  };

  useEffect(() => {
    if (!feiraId || !editando) return;

    const carregarDados = async () => {
      if (!feiraId) return;
      try {
        const [resConfig, resFormas, resCondicoes, resCampos, resEstandesBloqueio, resExpositoresBloqueio] = await Promise.all([
          fetchComAuth(`${api.API_URL}/feira/configuracao/${feiraId}`, {
            method: 'GET'
          }),
          fetchComAuth(`${api.API_URL}/forma-pagamento`, {
            method: 'GET'
          }),
          fetchComAuth(`${api.API_URL}/condicao-pagamento`, {
            method: 'GET'
          }),
          fetchComAuth(`${api.API_URL}/expositorCampos`, {
            method: 'GET'
          }),
          fetchComAuth(`${api.API_URL}/estandes-bloqueio/${feiraId}`, {
            method: 'GET'
          }),
          fetchComAuth(`${api.API_URL}/expositor-bloqueio/${feiraId}`, {
            method: 'GET'
          }),
        ]);
        const configData = await resConfig.json();
        const config = configData.data.dados[0];
        const formasGravadas = configData.data.formas_pagamento;
        const condicoesGravadas = configData.data.condicoes_pagamento;
        const contatosGravados = configData.data.contatos;
        const estandesBloqueioGravados = configData.data.bloqueios_estande;
        const expositoresBloqueioGravados = configData.data.bloqueios_expositor;
        const camposGravados = configData.data.campos_renovacao;

        if (config) {
          setConfiguracaoId(config.id);
          document.getElementById("nome_estande").value = config.nome_estande || '';
          document.getElementById("valor").value = config.valor || '';
          document.getElementById("altura_minima").value = config.altura_minima || '';
          document.getElementById("altura_maxima").value = config.altura_maxima || '';
          document.getElementById("largura").value = config.largura || '';
          document.getElementById("mensagem_padrao_comercial").value = config.mensagem_padrao_comercial || '';
          document.getElementById("comprimento").value = config.comprimento || '';
          document.getElementById("quantidade_dias_reserva").value = config.quantidade_dias_reserva || '';
          setEnviarEmailReserva(config.enviar_email_reserva || false);
          setContatosEmail(contatosGravados);

          document.getElementById("cor_principal").value = config.cor_principal || '#43c2cb';
          document.getElementById("cor_secundaria").value = config.cor_secundaria || '#364574';
          document.getElementById("cor_plano_fundo").value = config.cor_plano_fundo || '#ffffff';
          document.getElementById("corStatusLivrePicker").value = config.cor_status_livre || '#46b045';
          document.getElementById("corStatusReservadoPicker").value = config.cor_status_reservado || '#f2ad18';
          document.getElementById("corStatusVendidoPicker").value = config.cor_status_vendido || '#43c2cb';
          document.getElementById("corStatusRenovacaoPicker").value = config.cor_renovacao || '#46b045';
          document.getElementById("corStatusPendenteRenovacaoPicker").value = config.cor_pendente_renovacao || '#acd212';

          document.getElementById("tem_logo_expositor_mapa").checked = config.tem_logo_expositor_mapa || false;
          document.getElementById("permite_prorrogar_reserva").checked = config.permite_prorrogar_reserva || false;
          document.getElementById("obrigar_cpf_nome_renovacao").checked = config.obrigar_cpf_nome_renovacao || false;
          
          // Carregando Novos Campos
          setVendaInterna(config.venda_interna || false);
          setVendaExterna(config.venda_externa || false);
          setRenovacaoInterna(config.renovacao_interna || false);
          setRenovacaoExterna(config.renovacao_externa || false);
          setEnviarCodigoEmailExpositor(config.renovacao_com_senha || false);
          setEnviarEmailNovoUsuario(config.email_cria_usuario || false);
          setEnviarEmailReservaExpositor(config.email_expositor_nova_reserva || false);
          setEnviarEmailReservaComercial(config.email_organizacao_nova_reserva || false);
          setEnviarEmailAtualizacaoReservaExpositor(config.email_expositor_atualiza_reserva || false);
          setEnviarEmailAtualizacaoReservaComercial(config.email_organizacao_atualiza_reserva || false);
          setEnviarEmailAtualizarSenha(config.email_senha_atualizacao || false);
          setEnviarEmailQueroExpor(config.email_quero_expor || false);
        }
        const formasData = await resFormas.json();
        const condicoesData = await resCondicoes.json();
        const estandesBloqueioData = await resEstandesBloqueio.json();
        const expositoresBloqueioData = await resExpositoresBloqueio.json();
        const camposData = await resCampos.json();

        setFormasOpcoes(formasData.data.map(f => ({ value: f.id, label: f.nome })));
        setCondicoesOpcoes(condicoesData.data.map(c => ({ value: c.id, label: c.nome })));
        setEstandesOpcoes(estandesBloqueioData.data.map(e => ({ value: e.id, label: e.nome })));
        setExpositoresOpcoes(expositoresBloqueioData.data.map(e => ({ value: e.id, label: e.nome })));

        setCamposDisponiveis(camposData.data.map(item => ({
          value: item.nome,
          label: item.label
        })));

        if (config.logoDesenvolvedorUrl) {
          setLogoDevMapaUrl(config.logoDesenvolvedorUrl);
        }

        if (config.bannerUrl) {
          setBannerUrl(config.bannerUrl);
        }

        if (config.bannerMobileUrl) {
          setBannerMobileUrl(config.bannerMobileUrl);
        }

        if (config) {
          setSelectedFormas(formasData.data
            .filter(f => formasGravadas?.some(fg => fg.forma_pagamento_id === f.id))
            .map(f => ({ value: f.id, label: f.nome }))
          );

          setSelectedCondicoes(condicoesData.data
            .filter(c => condicoesGravadas?.some(cg => cg.condicao_pagamento_id === c.id))
            .map(c => ({ value: c.id, label: c.nome }))
          );

          setSelectedEstandesBloqueio(estandesBloqueioData.data
            .filter(c => estandesBloqueioGravados?.some(cg => cg.estande_id === c.id))
            .map(c => ({ value: c.id, label: c.nome }))
          );

          setSelectedExpositorBloqueio(expositoresBloqueioData.data
            .filter(c => expositoresBloqueioGravados?.some(cg => cg.expositor_id === c.id))
            .map(c => ({ value: c.id, label: c.nome }))
          );

          setSelected(camposData.data
            .filter(c => camposGravados?.some(cg => cg.nome_campo === c.nome))
            .map(c => ({ value: c.nome, label: c.label }))
          );
        }
      } catch (err) {
        console.error("Erro ao carregar a configuração feira", err);
      }
    };

    carregarDados();
  }, [feiraId]);

  const salvarConfiguracao = async () => {
    const toBase64 = (file) => new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
    });

    let logoBase64 = null;
    if (logoDevMapaFile) {
      logoBase64 = await toBase64(logoDevMapaFile);
    }

    let bannerBase64 = null;
    if (bannerFile) {
      bannerBase64 = await toBase64(bannerFile);
    }

    let bannerMobileBase64 = null;
    if (bannerMobileFile) {
      bannerMobileBase64 = await toBase64(bannerMobileFile);
    }

    const payload = {
      feira_id: feiraId,
      valor: document.getElementById("valor").value != '' ? parseFloat(document.getElementById("valor").value) : 0,
      nome_estande: document.getElementById("nome_estande").value,
      altura_minima: parseFloat(document.getElementById("altura_minima").value),
      altura_maxima: parseFloat(document.getElementById("altura_maxima").value),
      largura: document.getElementById("largura").value != '' ? parseFloat(document.getElementById("largura").value) : 0,
      comprimento: document.getElementById("comprimento").value != '' ? parseFloat(document.getElementById("comprimento").value) : 0,
      quantidade_dias_reserva: parseInt(document.getElementById("quantidade_dias_reserva").value),
      cor_principal: document.getElementById("cor_principal").value,
      cor_secundaria: document.getElementById("cor_secundaria").value,
      cor_plano_fundo: document.getElementById("cor_plano_fundo").value,
      cor_pendente_renovacao: document.getElementById("corStatusPendenteRenovacaoPicker").value,
      cor_status_livre: document.getElementById("corStatusLivrePicker").value,
      cor_status_reservado: document.getElementById("corStatusReservadoPicker").value,
      cor_status_vendido: document.getElementById("corStatusVendidoPicker").value,
      cor_renovacao: document.getElementById("corRenovacaoPicker").value,
      mensagem_padrao_comercial: document.getElementById("mensagem_padrao_comercial").value,
      enviar_email_reserva: enviarEmailReserva,
      formas_pagamento: selectedFormas.map(f => f.value),
      condicoes_pagamento: selectedCondicoes.map(c => c.value),
      bloqueios_estande: selectedEstandesBloqueio.map(f => f.value),
      bloqueios_expositor: selectedExpositorBloqueio.map(c => c.value),
      contatos: contatosEmail,
      campos_renovacao: selected.map(c => c.value),
      tem_logo_expositor_mapa: document.getElementById("tem_logo_expositor_mapa").checked,
      permite_prorrogar_reserva: document.getElementById("permite_prorrogar_reserva").checked,
      obrigar_cpf_nome_renovacao: document.getElementById("obrigar_cpf_nome_renovacao").checked,
      id: configuracaoId,

      venda_interna: vendaInterna,
      venda_externa: vendaExterna,
      renovacao_interna: renovacaoInterna,
      renovacao_externa: renovacaoExterna,
      renovacao_com_senha: enviarCodigoEmailExpositor,
      email_cria_usuario: enviarEmailNovoUsuario,
      email_expositor_nova_reserva: enviarEmailReservaExpositor,
      email_organizacao_nova_reserva: enviarEmailReservaComercial,
      email_expositor_atualiza_reserva: enviarEmailAtualizacaoReservaExpositor,
      email_organizacao_atualiza_reserva: enviarEmailAtualizacaoReservaComercial,
      email_senha_atualizacao: enviarEmailAtualizarSenha,
      email_quero_expor: enviarEmailQueroExpor,

      ...(logoDevMapaFile && { "logo_desenvolvedor_mapa": logoBase64 }),
      ...(bannerFile && { "banner": bannerBase64 }),
      ...(bannerMobileFile && { "banner_mobile": bannerMobileBase64 }),
    };
    try {
      const method = configuracaoId ? 'PUT' : 'POST';
      const url = `${api.API_URL}/configuracao`;

      const response = await fetchComAuthJson(url, {
        method: method,
        body: JSON.stringify(payload)
      });

      if (response.ok) {
        toast.success("Configuração salva com sucesso!");
      } else {
        throw new Error("Erro ao salvar");
      }
    } catch (err) {
      console.error("Erro ao salvar configuração:", err);
      toast.error("Erro ao salvar os dados informados da configuração!");
    }
  };


  return (
    <Row>
      <ToastContainer closeButton={false} />
      <div className="text-end" hidden>
        <button type="submit" className="btn btn-success w-sm" onClick={salvarConfiguracao}>Salvar</button>
      </div>

      <Col lg={12}>
        <Card>
          <CardHeader>
            <h5 className="card-title mb-0">Configuração Vendas/Renovação e E-mails</h5>
          </CardHeader>
          <CardBody>
            <Row>
              <Col lg={6}>
                <h6 className="mb-3">Controle de Disponibilidade</h6>
                <div className="d-flex flex-wrap gap-4">
                  <div className="mb-3">
                    <li className="d-flex align-items-center gap-2">
                      <div className="form-check form-switch form-switch-md">
                        <Input className="form-check-input" type="checkbox" role="switch" checked={vendaInterna} onChange={(e) => setVendaInterna(e.target.checked)} />
                      </div>
                      <label className="form-check-label fs-13 mb-0">Venda Interna</label>
                    </li>
                  </div>
                  <div className="mb-3">
                    <li className="d-flex align-items-center gap-2">
                      <div className="form-check form-switch form-switch-md">
                        <Input className="form-check-input" type="checkbox" role="switch" checked={vendaExterna} onChange={(e) => setVendaExterna(e.target.checked)} />
                      </div>
                      <label className="form-check-label fs-13 mb-0">Venda Externa</label>
                    </li>
                  </div>
                  <div className="mb-3">
                    <li className="d-flex align-items-center gap-2">
                      <div className="form-check form-switch form-switch-md">
                        <Input className="form-check-input" type="checkbox" role="switch" checked={renovacaoInterna} onChange={(e) => setRenovacaoInterna(e.target.checked)} />
                      </div>
                      <label className="form-check-label fs-13 mb-0">Renovação Interna</label>
                    </li>
                  </div>
                  <div className="mb-3">
                    <li className="d-flex align-items-center gap-2">
                      <div className="form-check form-switch form-switch-md">
                        <Input className="form-check-input" type="checkbox" role="switch" checked={renovacaoExterna} onChange={(e) => setRenovacaoExterna(e.target.checked)} />
                      </div>
                      <label className="form-check-label fs-13 mb-0">Renovação Externa</label>
                    </li>
                  </div>
                </div>
              </Col>

              <Col lg={6}>
                 <h6 className="mb-3">Segurança e Acessos</h6>
                 <div className="mb-3">
                    <li className="d-flex align-items-center gap-2">
                      <div className="form-check form-switch form-switch-md">
                        <Input className="form-check-input" type="checkbox" role="switch" checked={enviarCodigoEmailExpositor} onChange={(e) => setEnviarCodigoEmailExpositor(e.target.checked)} />
                      </div>
                      <div>
                        <label className="form-check-label fs-13 mb-0">Enviar código para iniciar renovação</label>
                      </div>
                    </li>
                  </div>
              </Col>
            </Row>

            <hr className="my-2" />

            <Row>
              <Col lg={12}>
                <h6 className=" mb-3 text-uppercase fs-12">Notificações Automáticas por E-mail</h6>
              </Col>
              
              <Col lg={6}>
                 <div className="mb-2">
                    <li className="d-flex align-items-center gap-2">
                      <div className="form-check form-switch form-switch-md">
                        <Input className="form-check-input" type="checkbox" role="switch" checked={enviarEmailReservaExpositor} onChange={(e) => setEnviarEmailReservaExpositor(e.target.checked)} />
                      </div>
                      <label className="form-check-label fs-13 mb-0">Reserva efetuada (Expositor)</label>
                    </li>
                  </div>
                  <div className="mb-2">
                    <li className="d-flex align-items-center gap-2">
                      <div className="form-check form-switch form-switch-md">
                        <Input className="form-check-input" type="checkbox" role="switch" checked={enviarEmailReservaComercial} onChange={(e) => setEnviarEmailReservaComercial(e.target.checked)} />
                      </div>
                      <label className="form-check-label fs-13 mb-0">Reserva efetuada (Comercial/Org.)</label>
                    </li>
                  </div>
                  <div className="mb-2">
                    <li className="d-flex align-items-center gap-2">
                      <div className="form-check form-switch form-switch-md">
                        <Input className="form-check-input" type="checkbox" role="switch" checked={enviarEmailAtualizacaoReservaExpositor} onChange={(e) => setEnviarEmailAtualizacaoReservaExpositor(e.target.checked)} />
                      </div>
                      <label className="form-check-label fs-13 mb-0">Atualização reserva (Expositor)</label>
                    </li>
                  </div>
                  <div className="mb-2">
                    <li className="d-flex align-items-center gap-2">
                      <div className="form-check form-switch form-switch-md">
                        <Input className="form-check-input" type="checkbox" role="switch" checked={enviarEmailAtualizacaoReservaComercial} onChange={(e) => setEnviarEmailAtualizacaoReservaComercial(e.target.checked)} />
                      </div>
                      <label className="form-check-label fs-13 mb-0">Atualização reserva (Comercial/Org.)</label>
                    </li>
                  </div>
              </Col>

              <Col lg={6}>
                  <div className="mb-2">
                    <li className="d-flex align-items-center gap-2">
                      <div className="form-check form-switch form-switch-md">
                        <Input className="form-check-input" type="checkbox" role="switch" checked={enviarEmailNovoUsuario} onChange={(e) => setEnviarEmailNovoUsuario(e.target.checked)} />
                      </div>
                      <label className="form-check-label fs-13 mb-0">Novo usuário</label>
                    </li>
                  </div>
                  <div className="mb-2">
                    <li className="d-flex align-items-center gap-2">
                      <div className="form-check form-switch form-switch-md">
                        <Input className="form-check-input" type="checkbox" role="switch" checked={enviarEmailAtualizarSenha} onChange={(e) => setEnviarEmailAtualizarSenha(e.target.checked)} />
                      </div>
                      <label className="form-check-label fs-13 mb-0">Senha atualizada</label>
                    </li>
                  </div>
                  <div className="mb-2">
                    <li className="d-flex align-items-center gap-2">
                      <div className="form-check form-switch form-switch-md">
                        <Input className="form-check-input" type="checkbox" role="switch" checked={enviarEmailQueroExpor} onChange={(e) => setEnviarEmailQueroExpor(e.target.checked)} />
                      </div>
                      <label className="form-check-label fs-13 mb-0">Solicitação 'Quero Expor' recebida</label>
                    </li>
                  </div>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Col>

      <Col lg={12}>
        <Card>
          <CardHeader><h6 className="card-title mb-0">Espaços</h6></CardHeader>
          <CardBody>
            <Row>
              <Col lg={2}>
                <div className="mb-3">
                  <Label className="form-check-label fs-14" htmlFor="nome_estande">Nome espaço:</Label>
                  <Input type="text" id="nome_estande" className="form-control" placeholder="Nome padrão dos espaços" />
                </div>
              </Col>


              <Col lg={2}><div className="mb-3"><Label className="form-check-label fs-14" htmlFor="valor">Valor m²:</Label><Input type="number" className="form-control" id="valor" placeholder="Valor padrão do m²" /></div></Col>
              <Col lg={2}><div className="mb-3"><Label className="form-check-label fs-14" htmlFor="altura_minima">Altura mín:</Label><Input type="number" className="form-control" id="altura_minima" placeholder="Altura mínima" /></div></Col>
              <Col lg={2}><div className="mb-3"><Label className="form-check-label fs-14" htmlFor="altura_maxima">Altura máx:</Label><Input type="number" className="form-control" id="altura_maxima" placeholder="Altura máxima" /></div></Col>
              <Col lg={2}><div className="mb-3"><Label className="form-check-label fs-14" htmlFor="largura">Largura:</Label><Input type="number" className="form-control" id="largura" placeholder="Largura padrão" /></div></Col>
              <Col lg={2}><div className="mb-3"><Label className="form-check-label fs-14" htmlFor="comprimento">Comprimento:</Label><Input type="number" className="form-control" id="comprimento" placeholder="Comprimento padrão" /></div></Col>
            </Row>
          </CardBody>
        </Card>
      </Col>


      <Col lg={12}>
        <Card>
          <CardHeader><h5 className="card-title mb-0">Reservas</h5></CardHeader>
          <CardBody>
            <Row>
              <Col lg={2}><div className="mb-3"><Label className="form-check-label fs-14" htmlFor="quantidade_dias_reserva">Dias para manter a reserva:</Label><Input type="number" className="form-control" id="quantidade_dias_reserva" placeholder="Dias válidos da reserva" /></div></Col>

              <Col lg={3}>
                <div className="mb-3">
                  <li className="d-flex">
                    <div className="flex-shrink-0">
                      <div className="form-check form-switch form-switch-lg">
                        <Input className="form-check-input" type="checkbox" role="switch" id="permite_prorrogar_reserva" />
                      </div>
                    </div>
                    <div className="flex-grow-1">
                      <label htmlFor="permite_prorrogar_reserva" className="form-check-label fs-14">Permite Prorrogar Reserva</label>
                      <p className="text-muted">Permitir que o comercial prorrogue o tempo padrão de reserva</p>
                    </div>
                  </li>
                </div>
              </Col>

              <Col lg={3}>
                <div className="mb-3">
                  <li className="d-flex">
                    <div className="flex-shrink-0">
                      <div className="form-check form-switch form-switch-lg">
                        <Input
                          className="form-check-input"
                          type="checkbox"
                          role="switch"
                          id="enviar_email_reserva"
                          checked={enviarEmailReserva}
                          onChange={(e) => setEnviarEmailReserva(e.target.checked)}
                        />
                      </div>
                    </div>
                    <div className="flex-grow-1">
                      <label htmlFor="enviar_email_reserva" className="form-check-label fs-14">Enviar e-mail</label>
                      <p className="text-muted">Notificar nova reserva por e-mail</p>
                    </div>
                  </li>
                </div>
              </Col>


              {enviarEmailReserva && (
                <div>
                  <Col xl={12} >
                    <Button color="success" size="sm" onClick={() => abrirModalContato()}>Adicionar Contato</Button>
                  </Col>

                  <Col xl={12}>
                    <ul className="table-responsive">
                      {contatosEmail.length === 0 ? (
                        <p className="text-muted">Nenhum contato cadastrado ainda.</p>
                      ) : (
                        <Table className="align-middle table-nowrap mb-0">
                          <thead>
                            <tr>
                              <th>Email</th>
                              <th>Ações</th>
                            </tr>
                          </thead>
                          <tbody>
                            {contatosEmail.map((contato) => (
                              <tr key={contato.id}>
                                <td>{contato.email}</td>
                                <td>
                                  <Button color="warning" size="sm" className="me-1" onClick={() => abrirModalContato(contato)}>Editar</Button>
                                  <Button color="danger" size="sm" onClick={() => excluirContato(contato.id)}>Excluir</Button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      )}
                    </ul>
                  </Col>

                </div>
              )}




            </Row>
          </CardBody>
        </Card>
      </Col>


      <Col lg={12}>
        <Card>
          <CardHeader><h5 className="card-title mb-0">Cores</h5></CardHeader>
          <CardBody>
            <Row>
              <Col lg={2}><div className="mb-3"><Label htmlFor="cor_principal" className="form-label">Cor Principal</Label><Input type="color" className="form-control form-control-color w-100" id="cor_principal" defaultValue="#43c2cb" /></div></Col>
              <Col lg={2}><div className="mb-3"><Label htmlFor="cor_secundaria" className="form-label">Cor Secundária</Label><Input type="color" className="form-control form-control-color w-100" id="cor_secundaria" defaultValue="#364574" /></div></Col>
              <Col lg={2}><div className="mb-3"><Label htmlFor="cor_plano_fundo" className="form-label">Plano Fundo Mapa</Label><Input type="color" className="form-control form-control-color w-100" id="cor_plano_fundo" defaultValue="#ffffff" /></div></Col>
              <Col lg={2}><div className="mb-3"><Label htmlFor="corStatusLivrePicker" className="form-label">Status Livre</Label><Input type="color" className="form-control form-control-color w-100" id="corStatusLivrePicker" defaultValue="#46b045" /></div></Col>
              <Col lg={2}><div className="mb-3"><Label htmlFor="corStatusReservadoPicker" className="form-label">Status Reservado</Label><Input type="color" className="form-control form-control-color w-100" id="corStatusReservadoPicker" defaultValue="#f2ad18" /></div></Col>
              <Col lg={2}><div><Label htmlFor="corStatusVendidoPicker" className="form-label">Status Vendido</Label><Input type="color" className="form-control form-control-color w-100" id="corStatusVendidoPicker" defaultValue="#43c2cb" /></div></Col>
            </Row>
            <Row>
              <Col lg={2}><div className="mb-3"><Label htmlFor="corStatusRenovacaoPicker" className="form-label">Status Renovado</Label><Input type="color" className="form-control form-control-color w-100" id="corStatusRenovacaoPicker" defaultValue="#cde212" /></div></Col>
              <Col lg={2}><div className="mb-3"><Label htmlFor="corStatusPendenteRenovacaoPicker" className="form-label">Status Pend.Renovação</Label><Input type="color" className="form-control form-control-color w-100" id="corStatusPendenteRenovacaoPicker" defaultValue="#cde212" /></div></Col>
            </Row>
          </CardBody>
        </Card>
      </Col>


      <Col lg={12}>
        <Card>
          <CardHeader><h5 className="card-title mb-0">Pagamentos</h5></CardHeader>
          <CardBody className="mb-4">
            <Row>
              <Col lg={6}>
                <div className="mb-3">
                  <Label htmlFor="formaPagamentoSelect" className="form-label">Forma de Pagamento</Label>
                  <Select
                    value={selectedFormas}
                    isMulti
                    onChange={setSelectedFormas}
                    options={formasOpcoes}
                    placeholder="Selecione ..."
                    styles={{
                      multiValueLabel: (styles) => ({
                        ...styles,
                        color: 'white', // Cor do texto do label
                        fontWeight: 'bold',         // Outras opções de estilo
                      }),
                      multiValue: (styles) => ({
                        ...styles,
                        backgroundColor: '#1a73e8', // Cor do chip como um todo (opcional)
                      }),
                    }}
                  />
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3">
                  <Label htmlFor="condicaoPagamentoSelect" className="form-label">Condição de Pagamento</Label>
                  <Select
                    value={selectedCondicoes}
                    isMulti
                    onChange={setSelectedCondicoes}
                    options={condicoesOpcoes}
                    placeholder="Selecione ..."
                    styles={{
                      multiValueLabel: (styles) => ({
                        ...styles,
                        color: 'white', // Cor do texto do label
                        fontWeight: 'bold',         // Outras opções de estilo
                      }),
                      multiValue: (styles) => ({
                        ...styles,
                        backgroundColor: '#1a73e8', // Cor do chip como um todo (opcional)
                      }),
                    }}
                  />
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Col>


      <Col lg={12}>
        <Card>
          <CardHeader>
            <h5 className="card-title mb-0">Mapa</h5>
          </CardHeader>
          <CardBody className="mb-4">
            <Row>

              <Col lg={6}>
                <div className="mb-3">
                  <Label className="form-label" htmlFor="desenvolvedor-mapa-logo-img">Logo Desenvolvedor do Mapa</Label>


                  {!logoDevMapaUrl && (
                    <Input
                      className="form-control"
                      id="logo-mapa-img"
                      type="file"
                      accept="image/png, image/gif, image/jpeg"
                      onChange={handleFileChange}
                    />
                  )}


                  {logoDevMapaUrl && (
                    <div style={{ display: "flex", flexWrap: "wrap", gap: "0.5rem" }}>
                      <div style={{ position: "relative" }}>
                        <img
                          src={typeof logoDevMapaUrl === "string" ? logoDevMapaUrl : URL.createObjectURL(logoDevMapaUrl)}
                          alt="Logo"
                          style={{
                            width: "80px",
                            height: "80px",
                            objectFit: "cover",
                            borderRadius: "4px",
                            backgroundColor: "#bb86fc"
                          }}
                        />
                        <button
                          type="button"
                          onClick={removeImage}
                          style={{
                            position: "absolute",
                            top: "-8px",
                            right: "-8px",
                            background: "#ff4444",
                            color: "white",
                            border: "none",
                            borderRadius: "50%",
                            cursor: "pointer"
                          }}
                        >
                          <i className="ri-close-fill align-bottom" />
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </Col>



              <Col lg={6}>
                <div className="mb-3">
                  <Label className="form-label" htmlFor="banner-feira-img">Banner</Label>


                  {!bannerUrl && (
                    <Input
                      className="form-control"
                      id="banner-feira-img"
                      type="file"
                      accept="image/png, image/gif, image/jpeg"
                      onChange={handleFileChangeBanner}
                    />
                  )}


                  {bannerUrl && (
                    <div style={{ display: "flex", flexWrap: "wrap", gap: "0.5rem" }}>
                      <div style={{ position: "relative" }}>
                        <img
                          src={typeof bannerUrl === "string" ? bannerUrl : URL.createObjectURL(bannerUrl)}
                          alt="Banner"
                          style={{
                            width: "80px",
                            height: "80px",
                            objectFit: "cover",
                            borderRadius: "4px",
                            backgroundColor: "#bb86fc"
                          }}
                        />
                        <button
                          type="button"
                          onClick={removeBanner}
                          style={{
                            position: "absolute",
                            top: "-8px",
                            right: "-8px",
                            background: "#ff4444",
                            color: "white",
                            border: "none",
                            borderRadius: "50%",
                            cursor: "pointer"
                          }}
                        >
                          <i className="ri-close-fill align-bottom" />

                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </Col>


              <Col lg={4}>
                <div className="mb-3">
                  <Label className="form-label" htmlFor="banner-feira-mobile-img">Banner Mobile</Label>


                  {!bannerMobileUrl && (
                    <Input
                      className="form-control"
                      id="banner-feira-mobile-img"
                      type="file"
                      accept="image/png, image/gif, image/jpeg"
                      onChange={handleFileChangeBannerMobile}
                    />
                  )}


                  {bannerMobileUrl && (
                    <div style={{ display: "flex", flexWrap: "wrap", gap: "0.5rem" }}>
                      <div style={{ position: "relative" }}>
                        <img
                          src={typeof bannerMobileUrl === "string" ? bannerMobileUrl : URL.createObjectURL(bannerMobileUrl)}
                          alt="Banner Mobile"
                          style={{
                            width: "80px",
                            height: "80px",
                            objectFit: "cover",
                            borderRadius: "4px",
                            backgroundColor: "#bb86fc"
                          }}
                        />
                        <button
                          type="button"
                          onClick={removeBannerMobile}
                          style={{
                            position: "absolute",
                            top: "-8px",
                            right: "-8px",
                            background: "#ff4444",
                            color: "white",
                            border: "none",
                            borderRadius: "50%",
                            width: "20px",
                            height: "20px",
                            cursor: "pointer"
                          }}
                        >
                          ×
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </Col>

              <Col lg={3}>
                <div className="mb-3">
                  <li className="d-flex">
                    <div className="flex-shrink-0">
                      <div className="form-check form-switch form-switch-lg">
                        <Input className="form-check-input" type="checkbox" role="switch" id="tem_logo_expositor_mapa" />
                      </div>
                    </div>
                    <div className="flex-grow-1">
                      <label htmlFor="tem_logo_expositor_mapa" className="form-check-label fs-14">Exibir logo do expositor no mapa</label>
                      <p className="text-muted">Permitir que seja visualizado o logo do expositor nos espaços já vendidos</p>
                    </div>
                  </li>
                </div>
              </Col>

              <Col lg={6}>

                <div className="mb-3">
                  <Label className="form-check-label fs-14" htmlFor="mensagem_padrao_comercial">Mensagem padrão whatsapp:</Label>
                  <Input type="text" id="mensagem_padrao_comercial" className="form-control" placeholder="Mensagem enviada nos contatos com o comercial" />
                </div>

              </Col>
            </Row>
          </CardBody>
        </Card>
      </Col>


      <Col lg={12}>
        <Card>
          <CardHeader>
            <h5 className="card-title mb-0">Renovação</h5>
          </CardHeader>
          <CardBody className="mb-4">
            <Row className="mb-3">
              <Label htmlFor="camposSelect" className="form-label">Dados que devem ser exibidos na Renovação</Label>
              <Select
                value={selected}
                isMulti
                onChange={setSelected}
                options={camposDisponiveis}
                placeholder="Selecione ..."
                classNamePrefix="js-example-basic-multiple mb-0"
                styles={{
                  multiValueLabel: (styles) => ({
                    ...styles,
                    color: 'white',
                    fontWeight: 'bold',
                  }),
                  multiValue: (styles) => ({
                    ...styles,
                    backgroundColor: '#1a73e8',
                  }),
                }}
              />
            </Row>


            <hr />


            <Col lg={12}>
              <div className="mb-3">
                <li className="d-flex">
                  <div className="flex-shrink-0">
                    <div className="form-check form-switch form-switch-lg">
                      <Input className="form-check-input" type="checkbox" role="switch" id="obrigar_cpf_nome_renovacao" />
                    </div>
                  </div>
                  <div className="flex-grow-1">
                    <label htmlFor="obrigar_cpf_nome_renovacao" className="form-check-label fs-14">Obrigar informar nome e cpf do responsável na renovação</label>
                    <p className="text-muted">Exigir que sejam informados o CPF e o nome do responsável pela efetivação da renovação
                    </p>
                  </div>
                </li>
              </div>
            </Col>


            <Row>
              <Col lg={6}>
                <div className="mb-3">
                  <Label htmlFor="estandesBloqueioSelect" className="form-label">Estandes bloqueados para renovação</Label>
                  <Select
                    value={selectedEstandesBloqueio}
                    isMulti
                    onChange={setSelectedEstandesBloqueio}
                    options={estandesOpcoes}
                    placeholder="Selecione ..."
                    styles={{
                      multiValueLabel: (styles) => ({
                        ...styles,
                        color: 'white', // Cor do texto do label
                        fontWeight: 'bold',         // Outras opções de estilo
                      }),
                      multiValue: (styles) => ({
                        ...styles,
                        backgroundColor: '#1a73e8', // Cor do chip como um todo (opcional)
                      }),
                    }}
                  />
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3">
                  <Label htmlFor="expositorBloqueioSelect" className="form-label">Expositores bloqueados para renovação</Label>
                  <Select
                    value={selectedExpositorBloqueio}
                    isMulti
                    onChange={setSelectedExpositorBloqueio}
                    options={expositoresOpcoes}
                    placeholder="Selecione ..."
                    styles={{
                      multiValueLabel: (styles) => ({
                        ...styles,
                        color: 'white', // Cor do texto do label
                        fontWeight: 'bold',         // Outras opções de estilo
                      }),
                      multiValue: (styles) => ({
                        ...styles,
                        backgroundColor: '#1a73e8', // Cor do chip como um todo (opcional)
                      }),
                    }}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={3}>
                <div>
                  <Label htmlFor="corRenovacao" className="form-label">Cor do Espaço Renovado</Label>
                  <Input type="color" className="form-control form-control-color w-100" id="corRenovacaoPicker" defaultValue="#43c2cb" />
                </div>
              </Col>
            </Row>


          </CardBody>


        </Card>
      </Col>


      <div className="text-end mb-4">
        <button type="submit" className="btn btn-success w-sm" onClick={salvarConfiguracao}>Salvar</button>
      </div>


      <Modal isOpen={modalContatoAberto} toggle={() => setModalContatoAberto(!modalContatoAberto)} centered>
        <ModalHeader toggle={() => setModalContatoAberto(!modalContatoAberto)}>
          {contatoEditandoId ? 'Editar Contato' : 'Novo Contato'}
        </ModalHeader>
        <ModalBody>
          <Form>
            <FormGroup>
              <Label>Email</Label>
              <Input type="email" value={emailContato} onChange={(e) => setEmailContato(e.target.value)} placeholder="exemplo@email.com" />
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setModalContatoAberto(false)}>Cancelar</Button>
          <Button color="primary" onClick={salvarContato}>{contatoEditandoId ? 'Atualizar' : 'Salvar'}</Button>
        </ModalFooter>
      </Modal>


    </Row>



  );
};


export default TelaConfiguracaoFeira;